import script from "./AutodeskViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutodeskViewer.vue?vue&type=script&setup=true&lang=ts"

import "./AutodeskViewer.vue?vue&type=style&index=0&id=6eb1d2a8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eb1d2a8"]])

export default __exports__